import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withRouter } from 'react-router-dom';

import Mail from '@material-ui/icons/Mail';

import { BlueRightArrowIcon } from '../../../../images/icons/WrapSvg';

class Template extends React.Component {
    handleClick = (event) => {
        this.props.history.push('/manage/templates/' + this.props.template.id);
    };

    render() {
        const { template, active, last } = this.props;
        const nombre = template.nombre.toUpperCase().trim();
        return (
            <div
                className={
                    'flex_full_row padding_top_24 padding_left_12 margin_left_24 c_grey_blue hand ' +
                    (active ? 'active' : '')
                }
                onClick={this.handleClick}
            >
                <Mail className={'c_bluish margin_right_12'} />
                <div
                    className={classNames(
                        'flex_full_row align_center',
                        last ? 'noshadow' : 'shadow_down',
                    )}
                >
                    <div className={'flex_full_row '}>
                        <span className="barlow_medium c_dark_grey_blue">{nombre}</span>
                    </div>
                    <BlueRightArrowIcon color="primary" />
                </div>
            </div>
        );
    }
}

Template.propTypes = {
    history: PropTypes.object.isRequired,
};

export default withRouter(Template);



// WEBPACK FOOTER //
// ./src/components/complex/manage/templates/Template.js